import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {
  PublicClientApplication,
  EventType,
  EventMessage,
  AuthenticationResult,
} from '@azure/msal-browser';
import config from './Config';
import ThemeProvider from 'react-bootstrap/esm/ThemeProvider';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';

const msalInstance = new PublicClientApplication({
  auth: {
    clientId: config.appId,
    authority: 'https://login.microsoftonline.com/f825d291-acbd-4d5b-a689-76361157b44c',
    redirectUri: config.redirectUri,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
  },
});

const accounts = msalInstance.getAllAccounts();
if (accounts && accounts.length > 0) {
  msalInstance.setActiveAccount(accounts[0]);
}

msalInstance.addEventCallback((event: EventMessage) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const authResult = event.payload as AuthenticationResult;
    msalInstance.setActiveAccount(authResult.account);
  }
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <ThemeProvider dir={document.documentElement.getAttribute('dir') || 'rtl'}>
        <App pca={msalInstance} />
      </ThemeProvider>
    </I18nextProvider>
  </React.StrictMode>
);
